// Central content + brand config for Big Buck Services, LLC.

export const CONTACT = {
  phone: "575-914-6069",
  email: "BigBuck_57@Hotmail.com",
  reviewUrl: "#", // OWNER TO PROVIDE: Google review URL once the Business Profile is verified
  location: "Hagerman, New Mexico",
  serviceArea: "Southeast New Mexico, Chaves, Eddy & Lea Counties, Delaware Basin",
};

export const BRAND = {
  shield: "/brand/shield.png",
  lockup: "/brand/lockup.png",
  tagline: "HAULING. DIRT WORK. SITE SUPPORT.",
  established: "EST. 2014",
};

export const IMG = {
  hero: "https://images.pexels.com/photos/30123684/pexels-photo-30123684.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1920",
  canyonPump:
    "https://images.unsplash.com/photo-1648369000096-109763c11e8e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  duskTruck:
    "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  sunriseField:
    "https://images.unsplash.com/photo-1516199423456-1f1e91b06f25?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  tanker:
    "https://images.unsplash.com/photo-1656988826404-bbb5ccb779bc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  silverTanker:
    "https://images.unsplash.com/photo-1586828909860-faf5ed195143?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  dozer:
    "https://images.pexels.com/photos/13923406/pexels-photo-13923406.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  grader:
    "https://images.pexels.com/photos/6070743/pexels-photo-6070743.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1600",
  rig: "https://images.unsplash.com/photo-1547455731-491e963f5e8c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  pumpSunset:
    "https://images.unsplash.com/photo-1778124691381-ee0ef169500c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  stormPump:
    "https://images.unsplash.com/photo-1585331664784-6aeeceab87e8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  sunPump:
    "https://images.unsplash.com/photo-1661864667506-c8d0dbd59004?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "Our Story", to: "/story" },
  { label: "Safety & Track Record", to: "/safety" },
  { label: "Contact", to: "/contact" },
];

export const CORE_SERVICES = [
  {
    icon: "Droplets",
    title: "Water Hauling",
    copy: "Fresh water delivery, produced water transport, and oilfield fluid hauling.",
  },
  {
    icon: "Mountain",
    title: "Dirt Work & Grading",
    copy: "Site prep, access road grading, pad construction, and excavation.",
  },
  {
    icon: "HardHat",
    title: "Oilfield Support",
    copy: "Reliable, responsive, owner-operated site services you can count on.",
  },
];

export const SERVICE_OPTIONS = [
  "Water Hauling and Transport",
  "Water Disposal Coordination",
  "Dirt Work and Grading",
  "Oilfield Site Support",
  "Other / Not Sure",
];

export const SERVICES = [
  {
    num: "01",
    title: "Water Hauling and Transport",
    image: IMG.tanker,
    copy: "Fresh water delivery, produced water transport, and oilfield fluid hauling across the Delaware Basin. Clean equipment, dependable scheduling, and drivers who know the field.",
    points: ["Fresh water delivery", "Produced water transport", "Oilfield fluid hauling"],
  },
  {
    num: "02",
    title: "Water Disposal Coordination",
    image: IMG.silverTanker,
    copy: "We coordinate disposal for upstream and midstream operators, routing loads, tracking volumes, and keeping your operation moving without the logistics headache.",
    points: ["Upstream & midstream coordination", "Disposal routing", "Volume tracking"],
  },
  {
    num: "03",
    title: "Dirt Work and Grading",
    image: IMG.dozer,
    copy: "Site preparation, access road grading, pad construction, and excavation. From the first cut to a finished pad, we build the ground your operation stands on.",
    points: ["Site preparation", "Access road grading", "Pad construction & excavation"],
  },
  {
    num: "04",
    title: "Oilfield Site Support",
    image: IMG.sunPump,
    copy: "Reliable, responsive, owner-operated site services. When you call Big Buck, you get the owner on the line and a crew that treats your location like their own.",
    points: ["Responsive dispatch", "Owner-operated", "Field-tested crews"],
  },
];

export const STORY_CHAPTERS = [
  {
    num: "01",
    heading: "One Truck. One Promise.",
    body: "Big Buck Services was founded in 2014 in Carlsbad, New Mexico, the heart of the Delaware Basin. It started with a single truck and a simple promise: show up, do the work right, and stand behind it.",
  },
  {
    num: "02",
    heading: "Earned, Not Given.",
    body: "One dependable load at a time, we grew from a single-truck operation into a trusted vendor for major operators, now serving multiple active accounts across Chaves, Eddy and Lea Counties.",
  },
  {
    num: "03",
    heading: "Through Every Cycle.",
    body: "We've navigated every major industry cycle over more than a decade. Through the highs and the downturns, our commitment to reliability, safety, and personal accountability never wavered.",
  },
  {
    num: "04",
    heading: "The Owner You Can Call.",
    body: "We're locally owned and owner-operated. That means when something matters, you're not routed through a call center. You talk to the person whose name is on the door.",
  },
];

export const PROOF_POINTS = [
  { stat: "11+", label: "Years unbroken with a leading Delaware Basin midstream client" },
  { stat: "2014", label: "Locally owned & operating in Hagerman, New Mexico" },
  { stat: "24/7", label: "Responsive, owner-accountable dispatch" },
  { stat: "3", label: "Counties served, Chaves, Eddy & Lea" },
];

export const SAFETY_PILLARS = [
  {
    icon: "ShieldCheck",
    title: "Safety-First Culture",
    copy: "Safety isn't a poster on the wall. It's how every load moves and every pad gets built. Professional operations, every single day.",
  },
  {
    icon: "CalendarClock",
    title: "Dependable Scheduling",
    copy: "Operators plan around us because we show up when we say we will. Consistent, on-time, and communicated.",
  },
  {
    icon: "Award",
    title: "Proven Track Record",
    copy: "An eleven-plus year unbroken operating history with a leading Delaware Basin midstream client speaks for itself.",
  },
];

// Client testimonials.
export const TESTIMONIALS = [
  {
    company: "Eastland Oil Company",
    person: "Phillip Hammond, Foreman",
    body: "Across a decade of hauling water for Eastland Oil Company, Big Buck earned a name for dependability. Foreman Phillip Hammond credits Bill Henson with consistently meeting every transfer deadline, without reminders, while delivering quality work each time. Eastland recommends Big Buck without reservation.",
  },
  {
    company: "Quatro Osos E&P, LLC",
    person: "Rory McMinn, President",
    body: "Quatro Osos has trusted Big Buck since 2018 for produced-water hauling, spill cleanup, and well-workover support across their Chaves County properties. President Rory McMinn points to Big Buck's Hagerman location as a real logistical advantage in a region where most services run out of Lovington, Hobbs, or Carlsbad. More than that, he values how Big Buck responds when the unexpected hits: when problems arise, Big Buck stands with its clients.",
  },
  {
    company: "Targa Resources",
    person: "Frankie Soto, Targa Northern Delaware",
    body: "Targa Resources confirms Big Buck as a trusted trucking partner, citing consistently good service across their Northern Delaware operations.",
  },
];
